import React from 'react';
import { Modal, Button } from 'antd';
import SelectInput from '../select';

interface FilterModalProps<T> {
  visible: boolean;
  onClose: () => void;
  onApply: (filters: T) => void;
  onClear: () => void;
  filters: T;
  fields: Array<{
    label: string;
    value: keyof T;
    options: { label: string; value: string }[];
    mode?: 'multiple' | 'tags';
    placeholder: string;
  }>;
}

const Index = <T extends NonNullable<unknown>>({
                                     visible,
                                     onClose,
                                     onApply,
                                     onClear,
                                     filters,
                                     fields,
                                   }: FilterModalProps<T>) => {
  return (
    <Modal
      title="Filters"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={650}
      className="custom-modal"
    >
      <div className="grid grid-cols-2 gap-x-6 gap-y-2">
        {fields.map((field) => (
          <div key={field.label}>
            <SelectInput
              label={field.label}
              options={field.options}
              placeholder={field.placeholder}
              clasNames="!text-[#007AFF] !bg-white text-[12px]"
              value={filters[field.value]}
              onChange={(val) =>
                onApply({ ...filters, [field.value]: val }) // Apply changes
              }
              mode={field.mode || 'multiple'}
            />
          </div>
        ))}
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-4 mt-4 bg-white">
        <Button
          className="bg-white text-[#4A4747] px-5 rounded-lg w-[115px] h-[40px] hover:!text-black hover:!border-[#DBD7D7]"
          onClick={onClear}
        >
          Clear
        </Button>
        <Button
          className="bg-[#BD273B] text-white hover:!text-white hover:!border-[#BD273B] px-5 rounded-lg w-[115px] h-[40px]"
          onClick={() => onApply(filters)}
        >
          Apply Filter
        </Button>
      </div>
    </Modal>
  );
};

export default Index;
